import { getFileFromParagraphs } from './common/api'
import { getLS, LS_KEYS } from './common/ls'
import { AirtableParagraphs } from './common/types'
import { showErrors } from './open-error-modal'

export const appendContent = async (context, paragraphs: AirtableParagraphs, pc?: number) => {
    const token = getLS(LS_KEYS.authKeyKey).value
    const text = await getFileFromParagraphs(token, paragraphs).catch(err => {
        showErrors(context, window, [err.message])
    })
    if (!text) return

    console.log(`Inserting`, text.length)
    const range = context.document.getSelection()
    console.log('range', range)
    const inserted = range.insertFileFromBase64(text, 'End', {
        importTheme: true,
        importStyles: false,
        importParagraphSpacing: true,
        importPageColor: true,
        importChangeTrackingMode: true,
        importCustomProperties: true,
        importCustomXmlParts: true,
        importDifferentOddEvenPages: true
    })
    console.log('ins', inserted)
    await context.sync()
}
